var required;
var email;
var current;

export default function forms() {
	$('body').on({
		'focus': function () {
			current = $(this);
			required = $(this).closest('.gfield_contains_required').length;
			email = $(this).closest('.ginput_container_email').length;
			if( current.val() === "" ) {
				toggleActive(current);
			}
		},
		'blur': function () {
			if( current.val() === "" && required ) {
				toggleActive(current);
				current.addClass('error');
				return;
			}
			if( current.val() === "" && !required ) {
				toggleActive(current);
			}
			if( current.val() !== "" && email ) {
				var valid = validateEmail(current.val());
				if(!valid) {
					current.addClass('error');
					return;
				}
				current.removeClass('error');
			}
			else { 
				current.removeClass('error'); 
			}
		}
	}, 'input').on({
		'click': function () {
			var form = $(this).closest('form');
			var hasErrors = form.find('.error').length;
			var hasEmptyRequired = form.find('.gfield_contains_required').find('input').val() === "";
			if( hasErrors || hasEmptyRequired ) {
				generateError(form);
				return false;
			}
			form.trigger('submit');
		}
	}, 'input[type="submit"]');
}

function validateEmail(email) {
	var re = /^(([^<>()[\]\\.,;:\s@\"]+(\.[^<>()[\]\\.,;:\s@\"]+)*)|(\".+\"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
	return re.test(email);
}
function toggleActive(field) {
	var label = field.parent().siblings('label');
	label.toggleClass('active');
}
function generateError(form) {
	var errors = form.find('.error');
	var requiredFields = form.find('.gfield_contains_required').find('input');

	requiredFields.each(function(index, el) {
		if( $(this).val() === '' ) {
			$(this).addClass('error');
		}
	});
	if( errors ) {
		// errors.each(function () {
		// 	console.log($(this));
		// });
	}
}


// WEBPACK FOOTER //
// ./app/js/components/forms.js